<template>
<el-collapse-item :name="item.id">
    <template slot="title">
      <div class="row">
        <div class="col s1" :class="'step-'+item.step">{{ numero }}</div>
        <div class="col s9" :class="'step-'+item.step">{{ item.cognome }}&#160;{{ item.nome }}</div>
        <div class="col s1 yo-align-right">{{item.codiceministeriale}}</div>
        <div class="col sm yo-align-right">{{item.step}}</div>
      </div>
    </template>
    
    <div class="row">

      <div class="col s3 yo-text-bold">ID</div>
      <div class="col s9">{{item.id}} </div>

      <div class="col s3 yo-text-bold clear">TIPOLOGIA</div>
      <div class="col s9">{{item.tipologia}} </div>

      <div class="col s3 yo-text-bold clear">LIVELLO</div>
      <div class="col s9">{{item.livello}} </div>

      <div class="col s3 yo-text-bold clear" v-if="item.codiceministeriale>1000">REGIONE</div>
      <div class="col s9"  v-if="item.codiceministeriale>1000">{{item.codiceministeriale | items($teras._struttura,"regione")}} </div>

      <div class="col s3 yo-text-bold clear">REFERENTE</div>
      <div class="col s9">{{ item.cntcognome }}&#160;{{ item.cntnome }}</div>

      <div class="col s3 yo-text-bold clear">EMAIL</div>
      <div class="col s9">{{ item.cntemail }}</div>

      <div class="col s3 yo-text-bold clear">CELLULARE</div>
      <div class="col s9">{{ item.cntcellulare }}</div>

      <div class="col s3 yo-text-bold clear">PAZIENTI (completi/inseriti)</div>
      <div class="col s9">{{ item.schede_completate }} su {{ item.schede_inserite }}</div>



      <div v-if="item.vonyear>2018"  class="col s3 yo-text-bold">CODICE VON</div>
      <div v-if="item.vonyear>2018"  class="col s9">{{item.codicevon}}</div>

      <div v-if="item.vonyear>2018" class="col s3 yo-text-bold">PAGAMENTO VON</div>
      <div v-if="item.vonyear>2018" class="col s9">{{item.vonyear}} pagato il {{item.vonpayment}}</div>

      <div v-if="item.vonyear>2018" class="col s3 yo-text-bold">ULTIMO PZ VON</div>
      <div v-if="item.vonyear>2018" class="col s9">{{item.lastvonnumber}}</div>

      <div v-if="item.vonyear>2018" class="col s3 yo-text-bold">NOTE VON</div>
      <div v-if="item.vonyear>2018" class="col s9">{{item.vonnote}}</div>

      <div class="col s3 yo-text-bold clear">ACCORDO CON SIN</div>
      <div class="col s9"><a v-if="item.doc1!=''" :href="'/upload/'+item.id+'/'+JSON.parse(item.doc1)[0].url" style="" target="_blank"><i class="material-icons">cloud_download</i></a></div>

      <div class="col s3 yo-text-bold clear">NOMINA AMMINISTRATORE</div>
      <div class="col s9"><a v-if="item.doc3!=''"  :href="'/upload/'+item.id+'/'+JSON.parse(item.doc3)[0].url" style="" target="_blank"><i class="material-icons">cloud_download</i></a></div>


      <div class="col s2 offset-s10 yo-align-center" v-if="$teras.utente.email=='teras@innsin.it'">
         <a class="yo-button small" v-if="item.step>2 && item.step<10" @click="centroAttiva()" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">thumb_up_alt</i></a>
         <a class="yo-button small" v-if="item.step<99" @click="centroDisattiva()" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">thumb_down_alt</i></a>
         <a class="yo-button small" @click="centroVon" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">school</i></a>
      </div>

      <div class="col s2 offset-s10 yo-align-center" v-if="$teras.utente.email=='von@terasmm.it'">
         <a class="yo-button small" @click="centroVon" style="color:#2E3C4A;padding-right:10px;"><i class="material-icons">school</i></a>
      </div>
   </div>


</el-collapse-item>

</template>


<script>
import emailAttivazione from './Email-attivazione.vue'
import dbItem from '../teras/dbItem'

export default {
  name: 'item-elenco',
   created () {
      this.$teras.pageHeader = 80
   },
   mounted () {
      this.$emit('scrollTop', 0)
   }
   ,data () {
      return {
         centro: {}
      }
   }
   ,props: {
      item: Object,
      numero: String
   }
   ,methods: {
      centroEmail(){
        var html = this.$teras.renderVue(emailAttivazione,{centro:this.item})
         this.$axios.email({from:'innsin@biomedia.net',oggetto:'INNSIN – Conferma abilitazione del Centro alla compilazione delle schede INNSIN',to:this.item.cntemail,body:html}).then((data) => {
            console.log("Email attivazione del centro inviata")
         }).catch((error) => {
            console.log("Errore nell'invio della email per l'attivazione del centro")
            console.log(error)
         })
      },
      centroAttiva () {
         this.$confirm('Il centro "'+this.item.nome+'" verrà attivato?', 'Warning', {
         confirmButtonText: 'Si',
         cancelButtonText: 'No',
         type: 'warning'
         }).then(async () => {
            this.centro = new dbItem({table:'centro'})
            await this.centro.load(this.item.id)
            console.log(this.centro)
            this.centro.row.step=10
            await this.centro.save()
            this.$teras.event.emit('centroLoad')
            this.centroEmail()
         }).catch(() => {
         this.$message({
               type: 'info',
               message: 'Operazione annullata'
         })         
         })
         
      },
      centroDisattiva () {
         this.$confirm('Il centro "'+this.item.nome+'" verrà disattivato?', 'Warning', {
         confirmButtonText: 'Si',
         cancelButtonText: 'No',
         type: 'warning'
         }).then(async () => {
            this.centro = new dbItem({table:'centro'})
            await this.centro.load(this.item.id)
            console.log(this.centro.row)
            this.centro.row.step=99
            await this.centro.save()
            this.$teras.event.emit('centroLoad')
         }).catch(() => {
         this.$message({
               type: 'info',
               message: 'Operazione annullata'
         })         
         })
         
      },
      centroVon(){
         this.$router.push('/centro-von/'+this.item.id)
      }
   }
}
</script>

<style>
.step-2{
  color:sandybrown;
}.step-3{
  color:lightseagreen;
}.step-10{
  color:seagreen;
}.step-99{
  color:red
}
</style>
